import { createUseStyles } from 'react-jss';

var styles = {
  sponsorLogo: {
    zIndex: 5,
    position: 'relative'
  }
};

var createStyles = createUseStyles(styles);
export { createStyles };
//# sourceMappingURL=styles.js.map